import React from "react";
import AddListItem from "./AddListItem";
import ListItems from "./ListItems";

function List({formId, list, answers, setAnswers}) {
	const listItems = answers.lists.find(value => value.id === list.id).value;

	function addListItem(item) {
		setAnswers(prev => {
			const newState = {...prev};
			let newLists = [...newState.lists];
			newState.lists = newLists;

			const foundValue = newLists.find(value => value.id === list.id);
			const newValue = {
				...foundValue
			};
			newValue.value = [...newValue.value, item];
			newLists[newLists.findIndex(value => value.id === list.id)] = newValue;
			return newState;
		});
	}

	function removeListItem(id) {
		setAnswers(prev => {
			const newState = {...prev};
			let newLists = [...newState.lists];
			newLists.find(value => value.id === list.id).value = newLists.find(value => value.id === list.id).value.filter(value => value.id !== id);
			newState.lists = newLists;
			return newState;
		});
	}
	return (
		<div className={"mb-3"}>
			<AddListItem formId={formId} id={list.id} name={list.name} listItems={listItems} addListItem={addListItem} min={list.min} max={list.max} type={list.type} />
			{listItems.length > 0 && <ListItems listItems={listItems} removeListItem={removeListItem} />}
		</div>
	);
}

export default List;
